module.exports = __webpack_public_path__ + "/images/cover-vendedores-phone-mockups.a967b8c.webp";